<template>
  <div>
    <v-col
      class="d-flex justify-space-between mx-auto py-5 flex-wrap container"
    >
    <ToolbarTitles :title="title" />
    </v-col>
    <v-dialog
      v-model="showEdit"
      :key="name"
      max-width="550px"
      persistent
      @keydown.esc="cancel"
      @keydown.enter="edit"
    >
      <v-card style="width: 550px">
        <v-card-title class="card__title pa-4">{{
          $tc("authorize.editRol")
        }}</v-card-title>
        <v-form ref="formEdit">
          <v-text-field
            dense
            outlined
            label="Nombre"
            v-model="name"
            :rules="rules"
            class="mx-4"
            @change="(event) => handleChange(event, 'nombre')"
          />
          <v-text-field
            dense
            outlined
            label="Descripción"
            v-model="description"
            :rules="rules"
            class="mx-4"
            @change="(event) => handleChange(event, 'descripcion')"
          />
          <v-autocomplete
            multiple
            :rules="rules"
            outlined
            v-model="insurable"
            :items="getInsurable"
            :item-text="truncateText"
            item-value="id"
            class="mx-4"
            label="Asegurable"
            :menu-props="{ auto: false, overflowY: true }"
            @change="(event) => handleChange(event, 'asegurables')"
          >
            <!-- item-text="codeDescription" -->
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index <= 1">
                <span>{{ item.name }}</span>
              </v-chip>
              <span v-if="index === 2" class="grey--text text-caption">
                (+ {{ insurable?.length - 2 }} )
              </span>
            </template>
          </v-autocomplete>
          <v-autocomplete
            multiple
            outlined
            :items="getOperators"
            v-model="operators"
            item-text="nombre"
            item-value="operId"
            :rules="rules"
            class="mx-4"
            label="Operadores"
            @change="(event) => handleChange(event, 'operadores')"
          >
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index <= 3">
                <span>{{ item.nombre }}</span>
              </v-chip>
              <span v-if="index === 4" class="grey--text text-caption">
                (+ {{ operators?.length - 4 }} )
              </span>
            </template>
          </v-autocomplete>

          <v-autocomplete
            dense
            outlined
            :items="getItemsMenuAsegurables"
            v-model="initPage"
            :rules="rulesInitPage"
            item-text="name"
            item-value="id"
            class="mx-4"
            label="Página de inicio"
            @change="(event) => handleChange(event, 'inicio')"
          />
        </v-form>
        <div class="d-flex justify-space-between px-4 pb-4">
          <v-btn class="bt-exit" @click="cancel">
            {{ $tc("editRegistrations.cancel") }}
          </v-btn>
          <v-btn class="bt-acept" @click="edit" :disabled="ischange">
            {{ $tc("editRegistrations.acept") }}</v-btn
          >
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDelete" :key="showDelete" max-width="350px" persistent @keydown.esc="closeDelete" @keydown.enter="deleteAction">
      <v-card max-width="350px">
        <v-card-title style="display: flex; justify-content: center">{{
          deleteTitle
        }}</v-card-title>
        <div style="display: flex; justify-content: center">
          <v-btn class="bt-exit mr-2 mb-2" @click="closeDelete">
            {{ $tc("editRegistrations.cancel") }}
          </v-btn>
          <v-btn class="bt-acept" @click="deleteAction">
            {{ $tc("editRegistrations.acept") }}</v-btn
          >
        </div>
      </v-card>
    </v-dialog>
    <div class="container">
      <v-card class="card_container mx-auto primary">
        <v-card-title class="d-flex justify-space-between">
          <v-text-field
            dense
            solo
            v-model="search"
            append-icon="mdi-magnify"
            :label="$tc('commons.search')"
            single-line
            hide-details
            class="search"
          />
          <v-col cols="auto" class="my-n4 pr-0">
            <v-row class="justify-start border ma-0">
              <!-- Botón de Refresh -->
              <v-col cols="auto pa-0">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      @click="refreshItems"
                      class="btn-table ma-1"
                      small
                    >
                      <v-icon
                        :class="{ loader: loading4 }"
                        :loading="loading4"
                        :disabled="loading4"
                        id="icon-add"
                        class="mx-auto"
                        size="19"
                      >
                        fas fa-sync-alt
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $tc("commons.refresh") }}</span>
                </v-tooltip>
              </v-col>

              <!-- Botón de Configurar Columnas -->
              <v-col cols="auto pa-0">
                <div class="d-flex justify-center">
                  <v-dialog
                    v-model="btnConfigColumns.menu"
                    max-width="400px"
                    @keydown.esc="toggleColumnMenu"
                    offset-x
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="white"
                            dark
                            icon
                            @click="toggleColumnMenu"
                            v-bind="attrs"
                            v-on="on"
                            class="btn-table ma-1"
                            small
                          >
                            <v-icon size="20">{{
                              btnConfigColumns.icon
                            }}</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ btnConfigColumns.tooltip }}</span>
                      </v-tooltip>
                    </template>
                    <v-card>
                      <v-text-field
                        v-model="columnFilter"
                        placeholder="Buscar columnas"
                        outlined
                        dense
                        hide-details
                        class="pa-2 pb-0 ma-0"
                      ></v-text-field>
                      <div
                        style="
                          min-width: 250px;
                          max-height: 250px;
                          overflow-y: scroll;
                          scrollbar-width: unset;
                        "
                        class="pa-2 pb-0 ma-0"
                        hide-details
                      >
                        <div
                          v-if="filteredColumns?.length === 0"
                          class="text-center px-2 pb-2"
                        >
                          <span
                            >No hay resultados que coincidan con la
                            búsqueda</span
                          >
                        </div>
                        <div v-else>
                          <div
                            v-for="column in filteredColumns"
                            :key="column.field"
                            hide-details
                          >
                            <v-checkbox
                              v-model="column.visible"
                              :label="column.text"
                              hide-details
                              class="my-auto mb-2"
                            ></v-checkbox>
                          </div>
                        </div>
                      </div>
                      <v-card-actions class="d-flex justify-space-between">
                        <v-btn class="bt-exit" @click="toggleColumnMenu">
                          <v-icon>fas fa-times</v-icon>
                        </v-btn>

                        <v-btn
                          color="bt-acept"
                          @click="
                            headersUpdated();
                            toggleColumnMenu();
                          "
                        >
                          <v-icon>fas fa-save</v-icon>
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </div>
              </v-col>

              <!-- Botón de Añadir -->
              <v-col cols="auto pa-0">
                <div>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="white"
                        dark
                        icon
                        class="btn-table ma-1"
                        small
                      >
                        <v-icon
                          size="20"
                          class="mx-auto"
                          id="icon-add"
                          v-bind="attrs"
                          v-on="on"
                          @click="openAdd"
                        >
                          fas fa-plus
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $tc("commons.add") }}</span>
                  </v-tooltip>
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-dialog
            v-model="showDialog"
            max-width="550px"
            persistent
            :key="showDialog"
            @keydown.esc="cancel"
            @keydown.enter="add"
          >
            <v-card style="max-width: 550px" class="text-center">
              <v-card-title class="card__title pa-4">
                {{ $tc("authorize.addRol") }}
              </v-card-title>
              <v-alert
                v-if="error"
                color="red"
                elevation="5"
                outlined
                text
                type="error"
                align="center"
                class="mx-1"
              >
                {{ alertValidate }}</v-alert
              >
              <v-form ref="form" v-model="valid">
                <v-text-field
                  dense
                  outlined
                  label="Nombre"
                  v-model="name"
                  :rules="rules"
                  class="mx-4"
                />
                <v-text-field
                  dense
                  outlined
                  label="Descripción"
                  v-model="description"
                  :rules="rules"
                  class="mx-4"
                />
                <v-autocomplete
                  :rules="rules"
                  multiple
                  outlined
                  v-model="insurable"
                  :items="getInsurable"
                  :item-text="truncateText"
                  item-value="id"
                  class="mx-4"
                  label="Asegurable"
                  @change="(event) => handleChange(event, 'asegurables')"
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index <= 1">
                      <span>{{ item.name }}</span>
                    </v-chip>
                    <span v-if="index === 2" class="grey--text text-caption">
                      (+ {{ insurable?.length - 2 }} )
                    </span>
                  </template>
                </v-autocomplete>
                <v-autocomplete
                  :rules="rules"
                  multiple
                  outlined
                  :items="getOpersnrol"
                  v-model="operators"
                  item-text="nombre"
                  item-value="operId"
                  class="mx-4"
                  label="Operadores"
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index <= 3">
                      <span>{{ item.nombre }}</span>
                    </v-chip>
                    <span v-if="index === 4" class="grey--text text-caption">
                      (+ {{ operators?.length - 4 }} )
                    </span>
                  </template>
                </v-autocomplete>
                <v-autocomplete
                  dense
                  outlined
                  :items="getItemsMenuAsegurables"
                  :rules="rulesInitPage"
                  v-model="initPage"
                  item-text="name"
                  item-value="id"
                  class="mx-4"
                  label="Página de inicio"
                  :disabled="!(this.initPageItems?.length > 0)"
                />
              </v-form>
              <div class="d-flex justify-space-between px-4 pb-4">
                <v-btn class="bt-exit" @click="cancel">
                  {{ $tc("editRegistrations.cancel") }}
                </v-btn>
                <v-btn class="bt-acept" @click="add">
                  {{ $tc("editRegistrations.acept") }}</v-btn
                >
              </div>
            </v-card>
          </v-dialog>
        </v-card-title>
        <v-divider class="mt-1"></v-divider>
        <v-data-table
          :key="tableKey"
          :headers="visibleHeaders"
          :items="getRoles"
          :single-expand="singleExpand"
          :expanded.sync="expanded"
          item-key="name"
          show-expand
          :hide-default-footer="true"
          disable-pagination
          :search="search"
          class="mx-auto"
          @item-expanded="onExpand"
          v-sortable-columns="handleColumnReorder"
          fixed-header
          :height="calculateMaxHeight"
          @refreshItems="refreshItems"
        >
          <template v-slot:expanded-item="{ headers }">
            <td :colspan="headers?.length" style="padding: 0px">
              <table style="width: 100%">
                <tr>
                  <th class="th__title">{{ $tc("authorize.insurable") }}</th>
                </tr>
                <tr class="tr__insu" v-if="insurableTb?.length != 0">
                  <td v-for="insu in insurableTb" :key="insu.id">
                    <v-chip class="ma-1 d-flex justify-center">{{
                      insu.nombre
                    }}</v-chip>
                  </td>
                </tr>
                <tr v-else>
                  <p style="color: grey" class="text-center">
                    {{ $tc("authorize.noInsu") }}
                  </p>
                </tr>
                <tr>
                  <th class="th__title">{{ $tc("authorize.operator") }}</th>
                </tr>
                <tr class="tr__oper" v-if="operatorsTb?.length != 0">
                  <td v-for="oper in operatorsTb" :key="oper.id">
                    <v-chip class="ma-1 d-flex justify-center">{{
                      oper.nombre
                    }}</v-chip>
                  </td>
                </tr>
                <tr v-else>
                  <p style="color: grey" class="text-center">
                    {{ $tc("authorize.noOper") }}
                  </p>
                </tr>
              </table>
            </td>
          </template>
          <template v-slot:item.actions="{ item }">
            <div class="d-flex justify-space-around" style="width: 100px">
                <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    <v-icon
                      id="icon-relation"
                      medium
                      class="mx-auto"
                      @click="openRelation(item)"
                    >
                    mdi-source-branch-plus
                    </v-icon>
                  </span>
                </template>
                <span>{{ $tc("autoriz.manageRelation") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    <v-icon
                      id="icon-edit"
                      small
                      class="mx-auto"
                      @click="openEdit(item)"
                    >
                      fas fa-pen
                    </v-icon>
                  </span>
                </template>
                <span>{{ $tc("editRegistrations.edit") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    <v-icon
                      id="icon-delete"
                      small
                      class="mx-auto"
                      @click="openDelete(item)"
                    >
                      fas fa-trash
                    </v-icon>
                  </span>
                </template>
                <span>{{ $tc("editRegistrations.delete") }}</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </div>
    <v-dialog v-model="setup" max-width="400px" style="min-height: 100px">
      <v-card max-width="400px">
        <v-card-title>
          <v-alert
            color="red"
            elevation="5"
            outlined
            text
            type="error"
            align="center"
          >
            {{ $tc("autoriz.irrestricto") }} {{ setupTitle }}
          </v-alert>
        </v-card-title>
        <v-card class="d-flex justify-center" color="accets">
          <v-btn @click="setup = false" class="bt-add mb-1 mr-1">{{
            $tc("commons.accept")
          }}</v-btn>
        </v-card>
      </v-card>
    </v-dialog>
      <dialog-relation
        @closeEditDialog="closeRelation"
        :dialog="showDialogRelation"
      ></dialog-relation>
    <Alerts :alert="errorAlert" :color="colorError" :textAlert="textAlert" />
    <Alerts :alert="ok" :color="colorOk" :textAlert="textAlert" />
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
  </div>
</template>

<script>
import DataTableEmp from "@/components/GestionEmpleados/commons/DataTableEmp.vue";
import roles from "@/store/autorizaciones/roles";
import relations from "@/store/autorizaciones/relations";
import configTable from "@/store/configuracionDeTablas/configTable.js";
import insurable from "@/store/common/insurable";
import Alerts from "@/components/GestionEmpleados/commons/Alerts.vue";
import Loader from "@/components/Complement/Loader.vue";
import ToolbarTitles from "@/components/Complement/ToolbarTitles.vue";
import Sortable from "sortablejs";
import DialogRelation from "./Relations/relationDialog.vue"
export default {
  components: { DataTableEmp, Alerts, Loader, ToolbarTitles, DialogRelation },
  data() {
    return {
      expanded: [],
      title: "Roles",
      singleExpand: true,
      isOperId: false,
      setup: false,
      tableKey: 0,
      btnConfigColumns: {
        menu: false,
        icon: "fas fa-cog",
        tooltip: "Columnas",
      },
      columnFilter: "",
      search: "",
      headers: [
         {
          text: "Nombre",
          value: "name",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Descripción",
          value: "description",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "100px",
        },
      ],
      showDialog: false,
      error: false,
      alertValidate: "",
      name: "",
      description: "",
      operators: [],
      insurable: [],
      rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
      data: {
        operadores: [],
      },
      rulesInitPage: [
        (v) =>
          this.insurable.includes(v) ||
          "Este elemento no se encuentra en los asegurables",
      ],
      colorError: "#FF8D58",
      colorOk: "#82A1D0",
      setupTitle: "",
      errorAlert: false,
      ok: false,
      textAlert: "",
      isLoading: false,
      showDelete: false,
      deleteTitle: this.$tc("autoriz.deleteRol"),
      rolId: {},
      valid: true,
      editItems: {},
      ischange: true,
      showEdit: false,
      insurableTb: [],
      operatorsTb: [],
      initPageItems: [],
      initPage: [],
      loader: null,
      loading4: false,
      showDialogRelation: false,
    };
  },

  mounted() {
    this.isLoading = true;
    let nameTable = this.title;
    configTable.commit("setColums", []);
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then((result) => {
        if (configTable.state.colums?.length === 0 || configTable.state.colums.length !== this.headers.length ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      })
      .finally(() => {
        roles.dispatch("getRoles").then(() => {
          this.isLoading = false;
        });
      });
  },
  computed: {
    calculateMaxHeight() {
      switch (true) {
        case this.getRoles?.length > 7:
          return "60vh";
      }
    },
    filteredColumns() {
      const filterText = this.columnFilter.toLowerCase();
      return this.allHeaders.filter((column) => {
        return column.text.toLowerCase().includes(filterText);
      });
    },
    visibleHeaders() {
      return this.allHeaders.filter((header) => header.visible);
    },
    allHeaders() {
      return Array.isArray(configTable.state?.colums)
        ? configTable.state.colums
        : [];
    },
    getRoles() {
      return roles.state.roles;
    },
    getInsurable() {
      return insurable.state.insurable;
    },

    getOperators: {
      get() {
        return roles.state.opersnrol;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    getItemsMenuAsegurables: {
      get() {
        return this.initPageItems;
      },
      set(newValue) {
        return newValue;
      },
    },
    getItemsMenu() {
      return insurable.state.initPage;
    },
    getOpersnrol: {
      get() {
        return roles.state.opersnrol.filter((e) => e.rolId == null);
      },
      set(newValue) {
        return newValue;
      },
    },
     open: {
      get() {
        return relations.state.open;
      },
      set(newvalue) {
        return newvalue;
      },
    },
  },
  methods: {
    async refreshItems() {
      this.loading4 = true;
      try {
        await roles.dispatch("getRoles");
      } finally {
        setTimeout(() => {
          this.loading4 = false;
        }, 2000);
      }
    },
    openRelation(item){
      relations.commit("setEdit", item)
      this.showDialogRelation=true
    },
    closeRelation(){
      this.showDialogRelation=false
      configTable.commit("setColums", []);
      let nameTable = this.title;
      configTable
        .dispatch("getColumsTableName", nameTable)
        .then(() => {
          if (configTable.state.colums.length === 0 || configTable.state.colums.length !== this.headers.length ) {
            this.saveConfigColumns();
          }
        })
        .catch((error) => {
          console.error("Error occurred:", error);
        });
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state?.colums;

      if (columnsToSave === undefined || this.allHeaders.length !== this.headers.length  || columnsToSave?.length === 0) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.title,
        json: JSON.stringify(columnsToSave),
      };

      configTable.commit("setNew", configData);

      configTable.dispatch("new");
    },
    handleColumnReorder(newIndex, oldIndex) {
      // Obtenemos todas las cabeceras desde la propiedad computada
      const allHeaders = [...this.allHeaders];

      // Extraemos las cabeceras visibles
      const visibleHeaders = allHeaders.filter((header) => header.visible);

      // Reordenamos solo las cabeceras visibles
      const movedHeader = visibleHeaders.splice(oldIndex - 1, 1)[0];
      visibleHeaders.splice(newIndex - 1, 0, movedHeader);

      // Creamos una nueva lista de cabeceras donde las cabeceras visibles reordenadas reemplazan a las originales
      let visibleIndex = 0;
      const newHeaders = allHeaders.map((header) => {
        if (header.visible) {
          return visibleHeaders[visibleIndex++];
        }
        return header;
      });

      // Actualizamos las cabeceras en el estado global
      configTable.state.colums = newHeaders;

      // Incrementamos la clave de la tabla para forzar la actualización
      this.tableKey++;
    },
    toggleColumnMenu() {
      this.btnConfigColumns.menu = !this.btnConfigColumns.menu;
    },
    truncateText(item) {
      const maxLength = 65;
      if (item.codeDescription?.length > maxLength) {
        return item.codeDescription.substring(0, maxLength) + "...";
      }
      return item.codeDescription;
    },
    isSetup(id) {
      return id === 1;
    },
    async openEdit(item) {
       this.$forceUpdate(); 
      if (this.isSetup(item.id)) {
        this.setupTitle = "editar";
        this.setup = true;
      } else {
        this.setup = false;
        this.isEdit = true;
        this.expanded = [];
        await this.dispatcher();
        roles.commit("setRolesId", item);
        await roles.dispatch("getRolesId").then(() => {
          this.showEdit = true;
          this.isLoading = false;
          this.name = item.name;
          this.description = item.description;
          this.initPage = roles.state.rolesId.paInicioAsegId;
          let newArrayOperators = [];
          let newArrayInsurable = [];
          let operadores = roles.state.rolesId.operators;
          let asegurables = roles.state.rolesId.insurable;
          asegurables?.forEach((e) => {
            newArrayInsurable.push(e.asegurableId);
          });
          operadores?.forEach((e) => {
            newArrayOperators.push(e);
          });

          this.insurable = newArrayInsurable;
          this.operators = newArrayOperators;
          this.initPageItems = asegurables?.map((e) => {
            return {
              id: e.asegurableId,
              name: e.nombre,
            };
          });

          const filterOperators = (this.getOperators =
            roles.state.opersnrol.filter((e) => {
              if (e.rolId == null) {
                return true;
              }
            }));
          const allOperators = this.operators.concat(filterOperators);
          roles.commit("setOperSnRol", allOperators);
        });
        this.editItems = {
          rolId: item.id,
        };
      }
    },
    openDelete(item) {
      if (this.isSetup(item.id)) {
        this.setup = true;
        this.setupTitle = "eliminar";
      } else {
        this.setup = false;
        this.rolId = item.id;
        this.showDelete = true;
      }
    },
    closeDelete(){
      this.showDelete = false
    },
    openAdd() {
      this.showDialog = true;
      this.dispatcher();
      this.ischange = false;
    },
    cancel() {
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
      this.ok = false;
      if (this.isEdit) {
        this.showEdit = false;
      } else {
        this.showDialog = false;
      }
      this.initPageItems = [];
      this.name = "";
      this.description = "";
      this.insurable = [];
      this.operators = [];
      this.ok = false;
      this.errorAlert = false;
      this.ischange = true;
      this.isEdit = false;
      this.isOperId = false;
      this.initPage = [];
    },

    edit() {
      let operatorsType = [];
      if (this.operators?.length == 0) {
        operatorsType = [];
      } else if (this.operators[0].operId) {
        this.operators[0].operId;
        this.operators.forEach((e) => {
          operatorsType.push(e.operId);
        });
      } else {
        operatorsType = this.operators;
      }

      this.editItems = {
        ...this.editItems,
        nombre: this.name,
        descripcion: this.description,
        asegurables: this.insurable,
        operadores: operatorsType,
        initPage: this.initPage,
      };
      roles.commit("setEdit", this.editItems);
      this.ok = false;
      roles
        .dispatch("edit")
        .then(() => {
          this.ok = true;
          this.textAlert = "Rol editado correctamente";
          roles.dispatch("getRolesId");
        })
        .catch((e) => {
          this.errorAlert = true;
          this.textAlert = e.response.data.error.message;
        });
      this.cancel();
    },
    add() {
      this.isLoading = true;
      let valid = this.$refs.form.validate();
      if (valid) {
        this.data = {
          nombre: this.name,
          descripcion: this.description,
          asegurables: this.insurable,
          operadores: this.operators,
          initPage: this.initPage,
        };
        roles.commit("setNew", this.data);
        roles
          .dispatch("new")
          .then(() => {
            this.ok = true;
            this.textAlert = "Rol creado correctamente";
          })
          .catch((e) => {
            this.errorAlert = true;
            this.textAlert = e.response.data.error.message;
          });
        this.cancel();

        this.showDialog = false;
      } else {
        this.error = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        setTimeout(() => {
          this.error = false;
        }, 2500);
      }
      this.isLoading = false;
    },
    deleteAction() {
      this.ok = false;
      roles.commit("setDeleteItem", this.rolId);
      roles
        .dispatch("delete")
        .then(() => {
          this.ok = true;
          this.textAlert = "El rol se elimino correctamente";
        })
        .catch((e) => {
          this.isLoading = false;
          this.errorAlert = true;
          this.textAlert = e.response.data.error.message;
        });
      this.closeDelete()
    },
    handleChange(event, type) {
      if (type === "asegurables") {
        const eventIds = Array.isArray(event)
          ? event.map((item) => item)
          : [event];
        this.initPageItems = this.getItemsMenu.filter((item) =>
          eventIds.includes(item.id)
        );
      }

      if (event) {
        this.ischange = false;
      }
    },
    async dispatcher() {
      await roles.dispatch("getOpersnrol");
      await insurable
        .dispatch("getInsurable")
        .then(() => (this.isLoading = false));
    },

    onExpand({ item, value }) {
      if (!value) {
        this.isLoading = false;
      } else {
        this.isLoading = true;
      }
      this.dispatcher();
      roles.commit("setRolesId", item);
      roles.dispatch("getRolesId").then(() => {
        this.insurableTb = roles.state.rolesId.insurable;
        this.operatorsTb = roles.state.rolesId.operators;
        this.isLoading = false;
      });
    },
  },
  directives: {
    sortableColumns: {
      inserted(el, binding) {
        const table = el.querySelector("table");
        const headerRow = table.querySelector("thead tr");
        const sortableHeaders = Array.from(headerRow.children);
        const options = {
          animation: 150,
          ghostClass: "sortable-ghost",
          onEnd: function (event) {
            const newIndex = event.newIndex;
            const oldIndex = event.oldIndex;
            binding.value(newIndex, oldIndex);
          },
        };
        Sortable.create(headerRow, options);
      },
    },
  },
};
</script>

<style>
.border {
  background-color: #1f324a2f;
  border-color: #a5b9d7;
  border-width: 5px;
  border-style: solid;
  border-radius: 25px;
}
.btn-table {
  background-color: #82a1d0;
}
.loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

#icon-add {
  color: #ffffff;
  margin-right: 8px;
}
#icon-edit {
  color: #39537a;
  font-size: 20px;
}
#icon-delete {
  color: #e2504c;
  font-size: 20px;
}

.search {
  max-width: 500px !important;
}

.text-start {
  padding: 7px !important;
}

th.text-start {
  background-color: #82a1d0 !important;
}

.tr__oper {
  display: grid;
  grid-template-columns: repeat(auto-fit, 187px);
  justify-content: center;
}

.tr__insu {
  display: grid;
  grid-template-columns: repeat(auto-fit, 187px);
  justify-content: center;
}

.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}
.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}

.bt-add {
  background-color: #39537a !important;
  color: white !important;
}

.card__title {
  display: flex;
  justify-content: center;
}

.th__title {
  border: 1px solid rgb(156, 151, 151) !important;
  background-color: #82a1d0;
  color: white;
}

::v-deep .v-data-table-header th {
  background-color: #82a1d0 !important;
}

::v-deep .v-data-table--fixed-header > .v-data-table__wrapper {
  background: #77dd77;
  overflow-y: scroll;
  scrollbar-width: unset;
}
.v-data-table--fixed-header > .v-data-table__wrapper {
  overflow-y: scroll;
  scrollbar-width: unset;
}
.container {
  max-width: 100%;
  padding-top: 1vh;
  padding-bottom: 1vh;
}
</style>
